module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Right Chaise_Stone.eaf8428c.png";